import React from 'react';
import PropTypes from 'prop-types';

import Grid from 'components/grid';
import MyPageLayout from 'components/my-page-layout';
import MyPageSection from 'components/my-page-section';
import Form from 'components/form';
import TextInput from 'components/text-input';
import PageSpinner from 'components/page-spinner';

const ChangeEmailPage = ({ form, layout, newEmail, oldEmail, section }) => {
  return (
    <MyPageLayout {...layout}>
      <Grid theme={Grid.themes.leftColumnWider}>
        <Grid.Column>
          <MyPageSection headingLevel={1} {...section}>
            <Form showSubmitButton={true} {...form}>
              {({ isLoading }) => (
                <React.Fragment>
                  <PageSpinner
                    shouldContainInParent={true}
                    isLoading={isLoading}
                  />
                  <TextInput
                    validations={['isRequired', 'isEmail']}
                    type="email"
                    autocomplete="email"
                    {...oldEmail}
                  />
                  <TextInput
                    validations={['isRequired', 'isEmail']}
                    type="email"
                    autocomplete="email"
                    {...newEmail}
                  />
                </React.Fragment>
              )}
            </Form>
          </MyPageSection>
        </Grid.Column>
      </Grid>
    </MyPageLayout>
  );
};

ChangeEmailPage.propTypes = {
  form: PropTypes.exact(Form.propTypes),
  layout: PropTypes.exact(MyPageLayout.propTypes),
  newEmail: PropTypes.exact(TextInput.propTypes),
  oldEmail: PropTypes.exact(TextInput.propTypes),
  section: PropTypes.exact(MyPageSection.propTypes)
};

export default ChangeEmailPage;
